export const GET_ATTENTIONS = 'GET_ATTENTIONS';
export const GET_ATTENTIONS_SUCCESS = 'GET_ATTENTIONS_SUCCESS';
export const GET_ATTENTIONS_ERROR = 'GET_ATTENTIONS_ERROR';

export const GET_AFFILIATES = 'GET_AFFILIATES';
export const GET_AFFILIATES_SUCCESS = 'GET_AFFILIATES_SUCCESS';
export const GET_AFFILIATES_ERROR = 'GET_AFFILIATES_ERROR';

export const SET_LIST_CONFIG = 'ATTENTIONS_SET_LIST_CONFIG';
export const SET_SELECTED_ATTENTION = 'SET_SELECTED_ATTENTION';
export const SET_SELECTED_AFFILIATE = 'SET_SELECTED_AFFILIATE';

// [MODULE_ACTIONS] EXPORT ACTION

const attentionsActions = {
    getAttentions: () => ({type: GET_ATTENTIONS}),
    getAttentionsSuccess: (response) => ({type: GET_ATTENTIONS_SUCCESS, response}),
    getAttentionsError: (error) => ({type: GET_ATTENTIONS_ERROR, error}),

    getAffiliates: () => ({type: GET_AFFILIATES}),
    getAffiliatesSuccess: (response) => ({type: GET_AFFILIATES_SUCCESS, response}),
    getAffiliatesError: (error) => ({type: GET_AFFILIATES_ERROR, error}),

    setListConfig: ({list, config}) => ({type: SET_LIST_CONFIG, list, config}),
    setSelectedAttention: (selectedAttention) => ({type: SET_SELECTED_ATTENTION, selectedAttention}),
    setSelectedAffiliate: (selectedAffiliate) => ({type: SET_SELECTED_AFFILIATE, selectedAffiliate}),
    // [MODULE_ACTIONS] DEFINE NEW ACTIONS
};

export default attentionsActions;
